import { Pipe, PipeTransform } from '@angular/core';
import { IDynamicModelOptions } from '@ups/xplat/dynamic-render';

/**
 * US 35432: the optional hint line under one typeahead option, from the control's
 * `options.itemHint`. Null when the control has no itemHint or the item has no hint,
 * so the option renders exactly as before.
 */
@Pipe({ name: 'dynamicItemHint', standalone: true })
export class DynamicItemHintPipe implements PipeTransform {
  transform(
    item: unknown,
    itemHint: IDynamicModelOptions['itemHint'] | null | undefined
  ): string | null {
    const hint = itemHint?.(item)?.trim();
    return hint ? hint : null;
  }
}
